export default __webpack_public_path__ + "static/media/verneText.247f1d66.png";